// services/symbolService.js
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';

async function get(exchange, format = 'objects') {
  if (!exchange) return [];
  const { data } = await axios.get(`${BASE}/api/symbolexchange`, {
    params: { exchange, format }
  });
  console.log('symbolService data:', data);
  return Array.isArray(data) ? data : [];
}

async function getFutures(exchange, marketType = 'usdm_futures', format = 'objects') {
  if (!exchange) return [];
  const { data } = await axios.get(`${BASE}/api/futuresymbolexchange`, {
    params: { exchange, market_type: marketType, format },
  });
  console.log('symbolService futures data:', exchange, marketType, data?.length);
  return Array.isArray(data) ? data : [];
}

export default { get, getFutures };